import {
  GetToursDataParams,
  GetToursDataResponse,
  SummaryDetails
} from 'services/api/type/report.type';
import { useQuery } from '@tanstack/react-query';
import API from 'services/api/index';
import QUERY_KEYS from 'services/api/queryKeys';
import get from 'lodash/get';
import { PAGE_SIZE_TOURS_DATA } from 'services/api/module/report.api';
import { PaginationType } from 'services/api/type/booking.type';

export const useGetToursData = (
  filterOptions: GetToursDataParams,
  page: number = 1,
  pageSize: number = PAGE_SIZE_TOURS_DATA
) => {
  const { data, status, isLoading, isFetching } = useQuery({
    queryKey: [QUERY_KEYS.GET_TOURS_DATA, page, pageSize, filterOptions],
    queryFn: () => API.report.getToursData(filterOptions, page, pageSize)
  });

  return {
    data: get(data, 'data.data.data', {}) as GetToursDataResponse,
    pagination: get(data, 'data.pagination', {}) as PaginationType,
    summaryDetails: get(data, 'data.data.summary_details', {}) as SummaryDetails,
    status,
    isLoading,
    isFetching
  };
};
